import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BenefitsFiguresComponent } from './benefits-figures.component'
import { SharedModule } from '../shared/shared.module'

@NgModule({
  declarations: [BenefitsFiguresComponent],
  exports: [BenefitsFiguresComponent],
  imports: [CommonModule, SharedModule],
})
export class BenefitsFiguresModule {}
